import { createFileRoute } from '@tanstack/react-router'
import { MarketingPage } from '@/features/marketing/components/marketing-page'
import { enContent } from '@/features/marketing/content'

export const Route = createFileRoute('/en/faq')({
  component: EnFaqPage,
})

function EnFaqPage() {
  return <MarketingPage {...enContent.faq} />
}
